module.exports = __webpack_public_path__ + "static/media/Excell.28e45c26.svg";